


































import VueOptions from '@utils/VueOptions'
import ActivationPlanDisplay from './ActivationPlanDisplay'

settings =
  name: 'ActivationPlanInCartWrapper'

  vue:
    props: ['item', 'activationPlan', 'actions', 'options']

    components: {
      ActivationPlanDisplay,
    }

    computed:
      displaySyncIndicator: ->
        @item.marked_for_sync || @item.marked_as_syncing

      editButtonTooltip: ->
        if @displaySyncIndicator
          return 'This listing is being updated, some values may change'
        ''

      hasActions: -> !!@actions.editActivationPlan || !!@actions.removeFromCartTrigger

export default VueOptions.vue settings
